export default __webpack_public_path__ + "66b622a25da168cc60ecd648c5cbbded.woff2";